import type { ElectricityPricesNarrativeInput } from './electricityPricesNarrative';
import { buildTrendSentence } from './optionalClauseTokens';
import type { NarrativeTokenMap } from './narrativeTemplateEngine';

export function buildElectricityPricesNarrativeTokens(input: ElectricityPricesNarrativeInput): NarrativeTokenMap {
  return {
    locationName: input.locationName,
    customerClassLabel: input.customerClassLabel,
    latestYear: input.latestYear,
    baselineYear: input.baselineYear,
    avgRevenuePerKwh: `$${input.avgRevenuePerKwh.toFixed(3)}/kWh`,
    trendSentence: buildTrendSentence(input.percentChange, input.baselineYear),
    trendPhrase: '',
    comparisonSentence: input.comparisonSentence || '',
  };
}
